import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { navigateToHome } from '../../utils/homeNavigation';

/** Shared link markup for footer Company / Legal / Actions columns. */
const FooterSiteLinkGroups = ({ headingClassName, listGapClass }) => (
  <>
    <div>
      <h3 className={headingClassName}>Company</h3>
      <ul className={`${listGapClass} space-y-2`}>
        <li>
          <Link to="/contact?tab=about" className="text-gray-400 hover:text-white transition-colors">
            About Us
          </Link>
        </li>
        <li>
          <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
            Contact
          </Link>
        </li>
      </ul>
    </div>
    <div>
      <h3 className={headingClassName}>Legal</h3>
      <ul className={`${listGapClass} space-y-2`}>
        <li>
          <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">
            Privacy Policy
          </Link>
        </li>
        <li>
          <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">
            Terms & Conditions
          </Link>
        </li>
      </ul>
    </div>
    <div>
      <h3 className={headingClassName}>Actions</h3>
      <ul className={`${listGapClass} space-y-2`}>
        <li>
          <Link to="/businesses/create" className="text-gray-400 hover:text-white transition-colors">
            Submit Business
          </Link>
        </li>
        <li>
          <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
            Advertise With Us
          </Link>
        </li>
      </ul>
    </div>
  </>
);

/**
 * Footer: Logo+tagline; Company/Legal/Actions (single collapsible below lg).
 * lg+: 4-column grid. Bottom bar: © + social placeholders.
 */
const Footer = ({ onNavigate }) => {
  const navigate = useNavigate();
  const [siteLinksOpen, setSiteLinksOpen] = useState(false);
  const groupHeadingDesktop = 'text-sm font-semibold text-white uppercase tracking-wider';

  const logoColumn = (
    <div>
      <button
        type="button"
        onClick={() => navigateToHome(navigate, onNavigate)}
        className="hover:opacity-80 transition-opacity"
        aria-label="PakPoints home"
      >
        <img src="/images/logo.svg" alt="PakPoints" className="h-10 w-10 text-white" />
      </button>
      <p className="mt-3 text-sm text-gray-400">
        Discover businesses and connect with communities across Pakistan.
      </p>
    </div>
  );

  return (
    <footer className="bg-gray-900 text-gray-300" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="lg:hidden space-y-8">
          {logoColumn}
          <div>
            <button
              type="button"
              className="w-full flex items-center justify-between text-sm font-semibold text-white uppercase tracking-wider pt-6 border-t border-gray-800"
              aria-expanded={siteLinksOpen}
              aria-controls="footer-site-links-panel"
              onClick={() => setSiteLinksOpen((open) => !open)}
            >
              <span>Company, Legal & Actions</span>
              <span className="text-base text-gray-400 font-normal" aria-hidden>
                {siteLinksOpen ? '−' : '+'}
              </span>
            </button>
            {siteLinksOpen && (
              <div id="footer-site-links-panel" className="mt-6 space-y-6">
                <FooterSiteLinkGroups
                  headingClassName="text-xs font-semibold text-white uppercase tracking-wider opacity-95"
                  listGapClass="mt-3"
                />
              </div>
            )}
          </div>
        </div>

        <div className="hidden lg:grid lg:grid-cols-4 lg:gap-12">
          {logoColumn}
          <FooterSiteLinkGroups headingClassName={groupHeadingDesktop} listGapClass="mt-4" />
        </div>

        <div className="mt-10 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">© PakPoints. All rights reserved.</p>
          <div className="flex items-center gap-4" aria-label="Social links">
            <span className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-gray-400 text-xs">
              f
            </span>
            <span className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-gray-400 text-xs">
              in
            </span>
            <span className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-gray-400 text-xs">
              t
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
